<template lang="pug">
	article.page-container.is-flex.is-full-height
		h1.title 404
		p.center-text This page doesn't exist or it's still under construction.
		button-themed(@click="onClick" spaced) Home
</template>

<script>
import ButtonThemed from '@/components/ButtonThemed'
export default {
	name      : 'Author',
	components: { ButtonThemed },
	metaInfo  : {
		title: '404 Error | Hukopedia'
	},
	methods: {
		onClick () {
			this.$router.replace('/')
		}
	}
}
</script>
